import React from "react";
import { useNavigate } from "react-router-dom";

//Assets
import IconHome from "../img/icons/Icono-Home.png";

export default function HomeButton() {
    const navigation = useNavigate();
    return(
        <div style={{position:"absolute", top:"15px", right:"0px",
        height:"50px", width:"55px", backgroundColor:"var(--black-color-80)",
        borderRadius:"10px 0px 0px 10px", display:"flex", cursor:"pointer"}}
        onClick={()=>navigation("home")}>
            <img src={IconHome} style={{height:"60%", margin:"auto"}} />
        </div>
    );
}